module.exports = __webpack_public_path__ + "img/微信图片_20220316141340.45f1300f.jpg";